import React from 'react';
import { useDropzone } from 'react-dropzone';
import '../../stylesheets/stylesComponents/input-file.scss';
import Icon from '../../muiComponents/Icon';
import useTranslate from '../../customHooks/useTranslate';

export default function InputFile({ onChange, onDrop, onClick }) {
    const translate = useTranslate();
    const { getRootProps, getInputProps } = useDropzone();

    return (
        <>
            <div
                {...getRootProps({
                    className: 'dropzone',
                })}
                onDrop={onDrop}
                onChange={onChange}
            >
                <input
                    {...getInputProps({
                        className: 'input__file',
                        onClick,
                    })}
                />
                <label htmlFor='file' className='label__file'>
                    <Icon iconName='CloudUpload' />
                    {translate('upload_file')}
                </label>
            </div>
        </>
    );
}
